export default __webpack_public_path__ + "bg-adaptive465878.png";